import { IconLibrary } from '@act/storybook';
import { Box, Typography } from '@mui/material';

export const LoadingScreenPostCall = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexGrow: 3,
        gap: 2,
        flexDirection: 'column',
        width: 'fit-content',
        alignSelf: 'center',
      }}
    >
      <IconLibrary iconName="Coffee" size={165}></IconLibrary>
      <Typography
        variant="titleLarge"
        color="surfaceContainer.contrastText"
        fontWeight="semibold"
        fontSize={28}
      >
        This might take a minute
      </Typography>
      <Box
        sx={{
          display: 'flex',
          maxWidth: '50%',
          px: 3,
        }}
      >
        <Typography
          variant="bodyLarge"
          color="surfaceContainer.contrastText"
          sx={{
            textIndent: '-24px',
          }}
        >
          Feel free to come back in a little bit to see your call summary
        </Typography>
      </Box>
    </Box>
  );
};
